import React from "react";
import './ProjectInfoSection.scoped.scss';
import {
  EditorJsBlock,
  EditorJsListItem,
  ProjectInfoSection as ProjectInfoSectionModel
} from "../../../../api-client";
import arrowIcon from "../../../../assets/images/svg/arrow-line-white.svg";
import {Image} from "../../../common";
import {cn, resultIf} from "../../../../utils";

type Props = ProjectInfoSectionModel;

const renderListItems = (items: Array<EditorJsListItem>): React.ReactNode => (
  items.map((item, index) => {
    const {content, items: nested} = typeof item === "string" ? {content: item, items: undefined} : item;
    return (
      <li key={index}>
        <span dangerouslySetInnerHTML={{__html: content}}/>
        {nested && nested.length > 0 && <ul>{renderListItems(nested)}</ul>}
      </li>
    );
  })
);

const renderBlock = (block: EditorJsBlock): React.ReactNode => {
  switch (block.type) {
  case "paragraph":
    return <p dangerouslySetInnerHTML={{__html: block.data.text}}/>;
  case "header": {
    const Tag = `h${block.data.level}` as keyof JSX.IntrinsicElements;
    return <Tag dangerouslySetInnerHTML={{__html: block.data.text}}/>;
  }
  case "list": {
    const ListTag = block.data.style === "ordered" ? "ol" : "ul";
    return <ListTag>{renderListItems(block.data.items)}</ListTag>;
  }
  case "delimiter":
    return <hr/>;
  default:
    return null;
  }
};

const ProjectInfoSection = ({title, background, content}: Props) => {
  const isGreen = background === "green";

  const icon = (
    <div className={cn("project-info-section__icon", isGreen ? "project-info-section__icon--green" : "project-info-section__icon--black")}>
      <Image
        className={cn("project-info-section__arrow", resultIf(isGreen, "project-info-section__arrow--flipped"))}
        src={arrowIcon}
        alt=""
      />
    </div>
  );
  const titleElement = <div className="project-info-section__title">{title}</div>;

  return (
    <div className={cn("project-info-section", isGreen ? "project-info-section--green" : "project-info-section--white")}>
      <div className="project-info-section__header">
        { isGreen ? <>{titleElement}{icon}</> : <>{icon}{titleElement}</> }
      </div>
      <div className="project-info-section__content">
        {content.blocks.map((block) => <React.Fragment key={block.id}>{renderBlock(block)}</React.Fragment>)}
      </div>
    </div>
  );
};

export default ProjectInfoSection;
